import React from "react";

import { withSections } from "./withSections";

import { AnalyticsCreativeSlot } from "~/components/AnalyticsCreativeSlot";

export const Sections = withSections(({ content }) => {
  return (content ?? [])
    .filter(Boolean)
    .map(({ component: Component, ...section }) => {
      if (!Component) return null;

      const { key, anchorId, nested } = section;

      return (
        <AnalyticsCreativeSlot
          key={key}
          id={anchorId}
          name={anchorId ?? section._type}
        >
          <Component {...section} as={nested ? "div" : "section"} />
        </AnalyticsCreativeSlot>
      );
    });
});
